import { useQuery } from "@tanstack/react-query";
import { getGoldenDatasetStatus } from "@/api/reviews";
import { goldenDatasetStatusQueryKey } from "./goldenDatasetStatusQueryKey";

export function useGoldenDatasetStatus(encounterId: string, { enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: goldenDatasetStatusQueryKey(encounterId),
    queryFn: () => getGoldenDatasetStatus(encounterId),
    enabled,
  });
}
